import { useGetStatisticsWidgets } from 'hook/query/useGetStatisticsWidgets'
import { useWidgetPreview } from '../context/WidgetPreviewContext'
import { STATISTICS_MOCK } from '../mocks/statisticsMock'

export const useWidgetStatistics = () => {
	const { isPreview } = useWidgetPreview()
	const real = useGetStatisticsWidgets({ enabled: !isPreview })

	if (isPreview) {
		return {
			statistics: STATISTICS_MOCK,
			loading: false,
			isError: false,
			error: undefined,
			refetch: () => {},
		}
	}

	return real
}
